// extracted by mini-css-extract-plugin
export default {"link":"style_link__DKgHd","centerGrid":"style_centerGrid__trHy5","img":"style_img__IxoOP","namegame":"style_namegame__UD9xb","center":"style_center__4AehV"};